import React, { useState } from "react";
import "./Switch.scss";

const Switch = ({ checked, onChange, label }) => {
  const [isChecked, setIsChecked] = useState(checked);

  const toggleSwitch = () => {
    const newValue = !isChecked;
    setIsChecked(newValue);
    onChange(newValue);
  };

  return (
    <div className="switch">
      <div className="label">{label}</div>
      <div
        className={`switch-toggle ${isChecked ? "checked" : ""}`}
        onClick={toggleSwitch}
      >
        <div className="switch-handle" />
      </div>
    </div>
  );
};

export default Switch;
